<template>
  <div id="footer" class="bg-secondary position-relative">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-8 d-flex mx-auto">
          <router-link :to="{ name: 'home' }">
            <img
              class="logo"
              src="@/assets/images/logo_bw.svg"
              alt="footer logo"
            />
          </router-link>
        </div>
        <div class="col-md-9">
          <div class="row information">
            <div class="col-md-5 col-8 info1 ml-auto mr-auto mr-md-0 mt-md-0">
              <ul>
                <li>電話：{{ info.tel }}</li>
                <li>傳真：{{ info.fax }}</li>
                <li>
                  Mail：
                  <a href="mailto:LTC@sp-mh.org">{{ info.mail }}</a>
                </li>
                <li>
                  地址：
                  <a
                    href="https://www.google.com.tw/maps/place/新北市泰山區新生路4號"
                    >{{ info.address }}</a
                  >
                </li>
              </ul>
            </div>
            <div class="d-none col-3 info2 d-md-flex justify-content-center">
              <ul class="two-column">
                <li>
                  <router-link
                    :class="{ active: $route.name === 'reservation' }"
                    :to="{ name: 'reservation' }"
                    >參訪實習</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'career' }"
                    :class="{
                      active:
                        $route.name === 'career' || $route.name === 'info',
                    }"
                    >徵才資訊</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'aboutUs', params: { id: 'environment' } }"
                    >環境場地</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'home', params: { id: 'transport' } }"
                    >交通資訊</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="d-none d-md-block col-3 info3">
              <ul>
              <li>
                <a
                  :href="info.FB"
                  class="d-flex align-items-center justify-content-center px-1 fb-btn"
                  target="_blank"
                >
                  <img src="@/assets/images/fb-logo.svg" alt="FB_logo" />
                  <span class="ml-2">臉書專頁</span>
                </a>
              </li>
              <li>
                <a
                  :href="info.Instagram"
                  class="d-flex align-items-center justify-content-center px-1 ig-btn"
                  target="_blank"
                >
                  <img src="@/assets/images/ig_logo.svg" class="ig-logo" alt="Instagram_logo" />
                  <span class="ml-1">Instagram</span>
                </a>
              </li>
              <li>
                <a
                  :href="info.donate"
                  class="d-flex align-items-center justify-content-center donate-btn"
                  target="_blank"
                >
                  <span class="ml-2">前往捐款</span>
                </a>
              </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-primary position-absolute">
      <p class="m-0 text-white text-center my-3">
        Copyright © 2020
        <br class="d-block d-sm-none" />財團法人天主教主顧修女會
        <br class="d-block d-sm-none" />All Rights Reserved
      </p>
    </div>
    <!-- <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: {
        tel: '02-2906-2242',
        tax: '06052813',
        fax: '02-2904-0420',
        web: 'www.miracle-esc.org.tw',
        mail: 'office@sp-mh.org',
        FB: 'https://www.facebook.com/%E4%B8%BB%E9%A1%A7%E4%BF%AE%E5%A5%B3%E6%9C%83%E5%A5%87%E8%B9%9F%E4%B9%8B%E5%AE%B6-314038992080726/',
        Instagram: 'https://www.instagram.com/miraclehome321/',
        address: '24353 新北市泰山區新生路4號',
        donate: 'https://miracle-esc.eoffering.org.tw/',
      },
    };
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/all.scss";

#footer {
  border-top: 3px solid $sub-primary;
  padding: 40px 0 120px;
  @media (min-width: 576px) {
    padding: 40px 0 80px;
  }
  @media (min-width: 768px) {
    border-top: none;
    padding: 65px 0 110px 0;
  }
  .logo {
    width: 100%;
    @media (min-width: 768px) {
      width: 100%;
    }
  }
  ul {
    list-style: none;
    color: white;
    padding: 0;
    margin: 0;
    li {
      margin-bottom: 5px;
      &:nth-of-type(4) {
        margin-bottom: 0;
      }
    }
  }
  a {
    color: white;
    text-decoration: none;
    &:hover,
    &.active {
      color: lighten($primary, 10%);
    }
  }
  .information {
    font-size: 12px;
    @media (min-width: 768px) {
      font-size: 15px;
    }
    .info1,
    .info2 {
      margin-top: 30px;
      @media (min-width: 768px) {
        margin-top: 0;
        border-right: 1px solid $secondary-white;
      }
    }
    .info1 li {
      margin-bottom: 5px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    .info3 a{
      padding: 5px;
      border-radius: 5px;
    }
    .fb-btn{
      color: white;
      background-color: $facebook;
    }
    .ig-btn{
      color: white;
      background: $ig;
    }
    .donate-btn{
      background-color: $peachy-pink;
    }
    a.donate-btn:hover{
       color: white;
      background-color: $peachy-pink;
    }
  }
  .position-absolute {
    bottom: 0;
    left: 0;
    right: 0;
    p {
      font-size: 12px;
    }
  }
  // .back {
  //   position: absolute;
  //   top: -7%;
  //   left: 50%;
  //   z-index: 9999;
  //   background: lighten($primary-light, 15%);
  //   width: 40px;
  //   height: 40px;
  //   border-radius: 50%;
  //   cursor: pointer;
  //   i {
  //     color: white;
  //     font-size: 40px;
  //   }
  // }
}
</style>
